import { useEffect, useState } from "react";
import { COUNTRIES, joinPhone, splitPhone } from "../lib/locations";

// A phone number with the country code already filled in (+250 for
// Rwanda), so people only type the rest. `value` and `onChange` use the
// full number, e.g. "+250788123456". Pass `dial` to tie the code to the
// country chosen elsewhere on the form.
export default function PhoneInput({ value, onChange, dial: fixedDial, placeholder = "788 123 456", className = "", ...props }) {
  const initial = splitPhone(value, fixedDial);
  const [dial, setDial] = useState(fixedDial || initial.dial);
  const [local, setLocal] = useState(initial.local);

  useEffect(() => {
    if (fixedDial && fixedDial !== dial) {
      setDial(fixedDial);
      onChange(joinPhone(fixedDial, local));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fixedDial]);

  const change = (nextDial, nextLocal) => {
    setDial(nextDial);
    setLocal(nextLocal);
    onChange(joinPhone(nextDial, nextLocal));
  };

  return (
    <div className={`flex h-11 w-full overflow-hidden rounded-xl border border-input bg-white text-sm focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/20 ${className}`}>
      {fixedDial ? (
        <span className="flex items-center border-r border-input bg-muted/50 px-3 font-medium text-slate-700">{dial}</span>
      ) : (
        <select
          value={dial}
          onChange={(e) => change(e.target.value, local)}
          aria-label="Country code"
          className="border-r border-input bg-muted/50 px-2 font-medium text-slate-700 outline-none"
        >
          {COUNTRIES.map((c) => (
            <option key={c.dial} value={c.dial}>
              {c.dial}
            </option>
          ))}
        </select>
      )}
      <input
        type="tel"
        inputMode="tel"
        autoComplete="tel-national"
        value={local}
        onChange={(e) => change(dial, e.target.value.replace(/[^\d\s]/g, ""))}
        placeholder={placeholder}
        className="min-w-0 flex-1 px-3 outline-none placeholder:text-muted-foreground"
        {...props}
      />
    </div>
  );
}
